import api from '../../api'
import {
  GET_TYPEFUEL_LIST_SUCCESS,
  GET_TYPEFUEL_LIST_FAILURE,
  GET_TYPEFUEL_FAILURE,
  GET_TYPEFUEL_SUCCESS,
  UPDATE_TYPEFUEL_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {
  getTypeFuelList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getTypeFuelList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        commit(GET_TYPEFUEL_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_TYPEFUEL_LIST_SUCCESS, {
        typefuelList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_TYPEFUEL_LIST_FAILURE)
      return reject(response.body.$error)
    })
  })

  },
 
  cleanTypeFuelList({commit}) {
    return commit(GET_TYPEFUEL_LIST_FAILURE)
  },
  getTypeFuel({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getTypeFuel(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_TYPEFUEL_FAILURE);
            reject();
          }
          commit(GET_TYPEFUEL_SUCCESS, {
            typefuel: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_TYPEFUEL_FAILURE);
          reject();
        })
    })
  },
 
  
  updateTypeFuel({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "name",
        "active"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateTypeFuel(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },


  createTypeFuel({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createTypeFuel(data)
      .then(response => {
        if (!response.ok) {
          api.stopLoader()
          return reject(response.body.$error);
        } else {
          api.stopLoader()
          return resolve(response.body.$success);
        }
      }, response => {
        api.stopLoader()
        return reject(response.body.$error);
      })
    })
  },
  
  
 
  deleteTypeFuel({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteTypeFuel(data)
         .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
    })
  },

  
  
};

const mutations = {

  [UPDATE_TYPEFUEL_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.typefuel));
  },
  [GET_TYPEFUEL_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_TYPEFUEL_LIST_SUCCESS](state, action) {
    state.list = action.typefuelList;
    state.listUpdated = new Date();
  },
  [GET_TYPEFUEL_FAILURE](state) {
    state.selected = null
  },
  [GET_TYPEFUEL_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.typefuel));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/typefuel.js